const experience = [
  {
    id: "wayfair",
    from: "June 2019",
    to: "Present",
    employer: "🛋 Wayfair",
    domain: "eCommerce",
    nextEmpId: "expedia",
    prevEmpId: "",
    details: [
      {
        role: "Senior Engineer",
        responsibilities: [
          "⎈ GIFT CARDS: Decoupled Java kafka consumer application",
          "Design ⦿ Architecture ⦿ Docker ⦿ Kafka ⦿ Avro ⦿ Java ⦿ Kubernetes ⦿ Test automation ",
          "⎈ FINANCING: Third party integration",
          "Design ⦿ PHP ⦿ Monolith ⦿ React ⦿ Redux ⦿ Test automation ⦿ vendor communication",
          "⎈ REGISTRY: Quiz platform",
          "Design ⦿ React ⦿ Redux ⦿ PHP ⦿ Test automation",
          "All the above were powered Kibana logging ⦿ Grafana Dashboards ⦿ Datadog APM",
        ],
      },
    ],
    skillsSet: [
      { percent: 100, text: "React", color: "red" },
      { percent: 100, text: "Redux", color: "blue" },
      { percent: 100, text: "PHP", color: "green" },
      { percent: 100, text: "Java", color: "orange" },
    ],
  },
  {
    id: "expedia",
    from: "May 2018",
    to: "June 2019",
    employer: "✈️ Expedia",
    domain: "TRAVEL AND HOSPITALITY",
    prevEmpId: "wayfair",
    nextEmpId: "wipro",
    details: [
      {
        role: "Full Stack Engineer",
        responsibilities: [
          "⎈ Partner management engine - Front end",
          "React ⦿ MobX ⦿ Jest ⦿ Browser stack integration",
          "Java 8 ⦿ Spring Boot ⦿ Front end server ⦿ JPA",
          "Using the standard toolkit and contributing to the UI toolkit",
          "GIT ⦿ Version controlled ⦿ Follow the standard review process ⦿ Review PRs",
          "Ensuring industry best practices in code reviews and application",
          "Sprint cerimonies ⦿ stand up ⦿ grooming ⦿ planning ⦿ demo",
          "Live applicaiton support ⦿ Flag issues ⦿ create more monotring dashboards ⦿ tickets for frquent issues",
        ],
      },
    ],
    skillsSet: [
      { percent: 100, text: "React", color: "red" },
      { percent: 100, text: "MOB-X", color: "blue" },
      { percent: 100, text: "Java", color: "orange" },
      { percent: 100, text: "SPRING", color: "green" },
    ],
  },
  {
    id: "wipro",
    from: "Sept 2010",
    to: "May 2018",
    employer: "📈Wipro",
    domain: "Service Provider",
    prevEmpId: "expedia",
    nextEmpId: "",
    details: [
      {
        role: "Full Stack Engineer",
        responsibilities: [
          "⎈ Client: Apple Inc - Team lead - US",
          "SAP ⦿ SAP UI5 ⦿ SAP Portal",
          "JS ⦿ D3⦿js,  SAP UI5",
          "Client relationship ⦿ requirement gathering ⦿ Flag risks ⦿ project planning",
          "⎈ Client: Jhonson & Jhonson - US/INDIA",
          "SAP ⦿ SAP Portal  SAP MDM, SAP BPM",
          "Production support ⦿ Report issues ⦿ Release planning ⦿ Indetifying risks and flagging at an earlier stage⦿",
          "⎈ Client: SAP - INDIA",
          "Cloud ⦿ Document as a service",
          "Java - Spring - JPA - jUnit - maven",
          "GIT ⦿ Learn how to push and pull code ⦿ Maintain a standard",
          "⎈ Client: BP - INDIA",
          "SAP ⦿ SAP Portal ⦿ SAP MDM ⦿ SAP Webdynpro Java ⦿ DTR(CVS)",
          "Production Support",
          "⎈ Client: Philips - INDIA",
          "SAP ⦿ SAP PI ⦿ SAP BPM ⦿ SAP BRM",
          "Client relationship ⦿ requirement gathering ⦿ Flag risks ⦿ Document issues",
          "⎈ Client: Kraft foods - INDIA",
          "SAP ⦿ SAP Portal ⦿ SAP MDM ⦿ SAP Webdynpro Java ⦿ DTR(CVS)",
          "Creating views and controllers",
          "🏁 . This is where everything BEGUN . 🏁 ",
        ],
      },
    ],
    skillsSet: [
      { percent: 100, text: "SAP", color: "red" },
      { percent: 100, text: "Java", color: "blue" },
      { percent: 100, text: "SAP UI5", color: "orange" },
      { percent: 100, text: "JS", color: "green" },
    ],
  },
];

export default experience;
